"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _T3UMQSFAcjs = require('../__chunks/T3UMQSFA.cjs');


var _7DAL4U2Wcjs = require('../__chunks/7DAL4U2W.cjs');


var _PCBS3ZKFcjs = require('../__chunks/PCBS3ZKF.cjs');
require('../__chunks/QWIBF3KB.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/toolbar/toolbar-container.tsx
var TagName = "div";
var useToolbarContainer = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useToolbarContainer2({ store, ...props }) {
    const context = _7DAL4U2Wcjs.useToolbarContext.call(void 0, );
    store = store || context;
    props = _PCBS3ZKFcjs.useCompositeContainer.call(void 0, { store, ...props });
    props = _T3UMQSFAcjs.useToolbarItem.call(void 0, { store, ...props });
    return props;
  }
);
var ToolbarContainer = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function ToolbarContainer2(props) {
    const htmlProps = useToolbarContainer(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.ToolbarContainer = ToolbarContainer; exports.useToolbarContainer = useToolbarContainer;
